import BookingHistoryColor from "@/app/components/ui/Reusable/BookingHistoryColor";
import BookingStatus from "@/app/components/ui/Reusable/BookingStatus";
import TableSkeleton from "@/app/components/ui/Skeletons/TableSkeleton";
import SlideoverWithStickyFooter from "@/app/components/ui/SlideOvers/SlideoverWithStickyFooter";
import { useBookingHistoryAPI } from "@/app/hooks/api_hooks/bookings/useBookingHistoryAPI";
import { useSlideoverState } from "@/app/hooks/ui_hooks/useSlideoverState";
import clsx from "clsx";
import { useState } from "react";
import ViewCommentModal from "./ViewComments";

interface IInvoiceDetailsSlideoverState {
  booking_id: string;
}
const BookingDetailsSlideOver = () => {
  const { booking_id } = useSlideoverState("BOOKING_DETAILS_VIEW") as IInvoiceDetailsSlideoverState;
  const [isBookingHitoruLoading, setIsBookingHitoruLoading] = useState<boolean>(false);
  const { execute: fetchBookingHistory, bookingDetails } = useBookingHistoryAPI();
  // const { truncateString } = useUtils();

  const handelFetchBookigHistory = () => {
    setIsBookingHitoruLoading(true);
    fetchBookingHistory(booking_id).then(({ status }) => {
      if (status) {
        setIsBookingHitoruLoading(false);
      } else {
        setIsBookingHitoruLoading(false);
      }
    });
  };

  return (
    <SlideoverWithStickyFooter
      title={<span className="font-bold">Booking History</span>}
      slideoverId="BOOKING_DETAILS_VIEW"
      onVisibleCallback={handelFetchBookigHistory}
      slideOverWidth="xl"
    >
      {!isBookingHitoruLoading ? (
        <div className="">
          {bookingDetails?.length > 0 ? (
            <table className="min-w-full divide-y divide-gray-300">
              <tbody className=" divide-gray-200 bg-white">
                {bookingDetails?.map((value, id) => {
                  return (
                    <div className="flex mb-3">
                      <li key={`${value.booking_date}:${id}`} className="relative flex gap-x-4">
                        <div className={clsx("absolute left-0 top-0 flex w-6 justify-center -bottom-6")}>
                          <div className="w-px bg-gray-200" />
                        </div>
                        <>
                          <div className="relative flex h-6 w-6 flex-none items-center justify-center bg-white">
                            <div className="h-1.5 w-1.5 rounded-full bg-blue-400 ring-1 ring-blue-500" />
                          </div>
                          <div className="">
                            <p className="flex-auto py-0.5 text-xs leading-5 text-gray-500">
                              {/* <span className="font-medium text-gray-900">{mp.membership_type}</span> Type */}
                            </p>
                          </div>
                        </>
                      </li>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-8 w-full mb-4" key={id}>
                        <div>
                          {id >= 1 ? (
                            <div>
                              <div className="flex flex-wrap mb-1 gap-1">
                                <p className="font-medium">Updated By : </p>
                                <p className="break-words">{value?.updated_by}</p>
                              </div>
                              <div className="flex flex-wrap mb-1 gap-1">
                                <p className="w-20 font-medium">Updated At : </p>
                                <p className="text-left break-words">{value?.updated_at}</p>
                              </div>
                            </div>
                          ) : (
                            <div>
                              <div className="flex flex-wrap mb-1 gap-1">
                                <p className="font-medium">Created By : </p>
                                <p className="break-words">{value?.created_by}</p>
                              </div>
                              <div className="flex flex-wrap mb-1 gap-1">
                                <p className="w-20 font-medium">Created At : </p>
                                <p className="break-words">{value?.created_at}</p>
                              </div>
                            </div>
                          )}
                        </div>
                        <div>
                          <div className="grid grid-cols-2 gap-2 mb-1">
                            <p className="w-32">Status : </p>
                            <BookingHistoryColor bookingStatus={value?.booking_status?.toLowerCase()} />
                          </div>
                          {value?.update_event && (
                            <div className="grid grid-cols-2 gap-2 mb-1">
                              <p className="w-32">Reason : </p>
                              <p className="capitalize break-words">{value.update_event.replaceAll("_", " ")}</p>
                            </div>
                          )}
                          <div className="grid grid-cols-2 gap-2 mb-1">
                            <p className="w-32">Source : </p>
                            <p>{value?.creation_source}</p>
                          </div>
                          <div className="grid grid-cols-2 gap-2 mb-1">
                            <p className="w-32">Booking Type : </p>
                            <p>{value?.booking_type}</p>
                          </div>

                          <div className="grid grid-cols-2 gap-2 mb-1">
                            <p className="w-32">Booking Time : </p>
                            <p>{value?.booking_start_time}</p>
                          </div>
                          <div className="grid grid-cols-2 gap-2 mb-1">
                            <p className="w-32">Booking Date : </p>
                            <p>{value?.booking_date}</p>
                          </div>

                          <div className="grid grid-cols-2 gap-2 mb-1">
                            <p className="w-32">Coupon Code : </p>
                            <p>{value?.coupon_code || "NA"}</p>
                          </div>
                          <div className="grid grid-cols-2 gap-2 mb-1">
                            <p className="w-32">Staff Name : </p>
                            <p>{value?.staff_name}</p>
                          </div>
                          <div className="grid grid-cols-2 gap-2 mb-1">
                            <p className="w-32">Service Name : </p>
                            <p>{value?.sub_service_name}</p>
                          </div>
                          <div className="grid grid-cols-2 gap-2 mb-1">
                            <p className="w-32">Subservice Name : </p>
                            <p>{value?.sub_service_name}</p>
                          </div>
                          <div className="grid grid-cols-2 gap-2 mb-1">
                            <p className="w-32">Clinic Name : </p>
                            <p>{value?.clinic_name}</p>
                          </div>

                          <p className="w-32">Comments: </p>
                        </div>
                        <div className=" gap-2 w-full mb-1 flex justify-center  "></div>
                        <ViewCommentModal appointmentNotes={value?.Comments} />
                      </div>
                    </div>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <p>No Data Found</p>
          )}
        </div>
      ) : (
        <TableSkeleton />
      )}
    </SlideoverWithStickyFooter>
  );
};

export default BookingDetailsSlideOver;
